import type {
    SiteAnalyticsDataRequest,
    SiteAnalyticsDataResult,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';
import type {
    SiteAnalyticsPageDefinition,
    SiteAnalyticsPageDefinitionDeps,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-definition.type';
import {
    buildEventsScaffoldConfig,
    loadEventsTabData,
} from '@client/app/feature-modules/site-analytics/definitions/events-definition.utils';

const EVENTS_CATEGORIES_CONFIG = buildEventsScaffoldConfig({
    tableKey: 'site-analytics-events-categories',
    dataSource: 'eventsCategories',
    exportCategory: 'event_categories',
    tableCaptionKey: 'siteAnalytics.events.categories.table.caption',
    primaryColumnHeaderKey: 'siteAnalytics.events.table.column.category',
    secondaryColumnHeaderKey: 'siteAnalytics.events.table.column.action',
    primarySortField: 'event_category',
});

const loadEventsCategoriesData = (
    request: SiteAnalyticsDataRequest,
    deps: SiteAnalyticsPageDefinitionDeps,
): Promise<SiteAnalyticsDataResult> => {
    return loadEventsTabData(
        request,
        deps,
        (domainId, params) => deps.statisticsEventsRepoService.getEventsCategories(domainId, params),
        'event_actions',
    );
};

export const EVENTS_CATEGORIES_DEFINITION: SiteAnalyticsPageDefinition = {
    key: 'eventsCategories',
    config: EVENTS_CATEGORIES_CONFIG,
    loadData: loadEventsCategoriesData,
};

export const EVENTS_CATEGORIES_PAGE_CONFIG = EVENTS_CATEGORIES_DEFINITION.config;
